import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProductsByUUIDs } from "../../../api/reviews";
import { ProductUUID } from "../../../models/nominals";
import { IReviewsProduct } from "../../../models/reviews";

/**
 * Load specific products by their UUIDs.
 *
 * Fetches a subset of products by their universally unique identifiers. Used when
 * the app knows exactly which products to display (e.g., from URL parameters or
 * user's purchase history).
 *
 * @param {ProductUUID[]} productUUIDs - Array of product UUIDs to fetch
 *
 * @returns {Promise<IReviewsProduct[]>} Promise resolving to array of matching products
 *
 * @example
 * // Load specific products by UUID
 * dispatch(loadProductsByUUIDs([
 *   'uuid-123',
 *   'uuid-456'
 * ]));
 *
 * @sideEffects
 * - Updates `data.products` with fetched products via extraReducers
 * - Sets `data.loadedInitialProducts` to true via extraReducers
 */
export const loadProductsByUUIDs = createAsyncThunk(
    "reviews/loadProductsByUUIDs",
    async (
        productUUIDs: readonly ProductUUID[],
    ): Promise<readonly IReviewsProduct[]> => {
        const products = await getProductsByUUIDs(productUUIDs);
        return products;
    },
);
